import React from 'react';
import { getAuthorisationLetterHtml } from './AuthorizationLetterHtml';

function AuthorisationLetterPrint({ componentRef, data }) {
    return (
        <div ref={componentRef} style={{ padding: 20 }}>
            <div dangerouslySetInnerHTML={{
                __html: getAuthorisationLetterHtml(data)
            }}>

            </div>
        </div>
    );
}

export default AuthorisationLetterPrint;
